import React from 'react';

import { voiceItems } from '../content';

const CommonImageSquare = ({ item }) => {
  return (
    <div className="advanced-square-wrapper">
      <img
        src={`/assets/images/icons/${voiceItems[item?.type]?.icon}.svg`}
        alt=""
      />
      <span className="advanced-name">{voiceItems[item?.type]?.title}</span>
    </div>
  );
};

export default CommonImageSquare;
